import { graphql } from '@packages/core/graphql/types';
import { useQuery } from '@apollo/client';

export const COMPANY_COUNT_QUERY = graphql(`
  query CompanyCount {
    companyCount
  }
`);

export function useCompanyCount() {
  return useQuery(COMPANY_COUNT_QUERY);
}
